<template>
  <div>
    <Accordion :activeIndex="activeIndex">
	    <AccordionTab header="Filtro">
        <d-form-row>
	    	  <d-col md="4" class="form-group">
            <label>Data de Vencimento Inicial</label>
            <date-field v-model="filter.DateInitial" :maxDate="filter.DateEnd" />
            <div class="invalid-feedback d-block" v-if="isFilterDateInvalid">
              Deve ser menor ou igual à Data Final.
            </div>
          </d-col>
          <d-col md="4" class="form-group">
            <label>Data de Vencimento Final</label>
            <date-field v-model="filter.DateEnd" :minDate="filter.DateInitial"/>
            <div class="invalid-feedback d-block" v-if="isFilterDateInvalid">
              Deve ser maior ou igual à Data Inicial.
            </div>
          </d-col>
          <d-col md="4" class="form-group">
            <label>Valor</label>
            <decimal-field :disabled="true" :type="'currency'" v-model="filter.AmountInitial" />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Banco</label>
            <d-select v-model="filter.BankCode">
              <option :value="null" selected>Todos</option>
              <option v-for="bank in filterOptions.Banks" :value="bank.Code" :key="bank.Code">
                {{ bank.Name }}
              </option>
            </d-select>
          </d-col>
          <d-col md="6" class="form-group">
            <label>Conta</label>
            <d-select v-model="filter.BankAccountsCode">
              <option :value="null" selected>Todas</option>
              <option v-for="bankAccount in filterOptions.BankAccounts" :value="bankAccount.Code" :key="bankAccount.Code">
                {{ bankAccount.BankAccount }}-{{bankAccount.BankAccountDigit}}
              </option>
            </d-select>
          </d-col>
          <d-col md="11" class="form-group">
            <label>Descrição</label>
            <d-form-input type="text" v-model="filter.Description" />
          </d-col>
          <d-col md="1" class="form-group align-vertical-bottom">
            <b-button class="btn btn-primary" @click="ListUnconciliatedTransfer()" title="Pesquisar" 
              v-b-tooltip.hover.bottom variant="primary" :disabled="isFilterDateInvalid">
              <i class="fas fa-search" />
            </b-button>
          </d-col>
        </d-form-row>
	    </AccordionTab>
    </Accordion>
    <TableList v-if="listUnconciliatedTransfer" :headers="headers" :itemList="listUnconciliatedTransfer" 
        @List="ListUnconciliatedTransfer" :authorizeActions="[]" :pagination="pagination" :isLoading.sync="loading"
        :additionalActions="additionalActions" @MakeConciliation="MakeConciliation" :noHeader="true"/>
  </div>
</template>

<script>
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import TableList from "../../sub-components/Generic/TableList/TableList.vue";
import DateField from "../../common/date-field";
import DecimalField from "../../common/decimal-field.vue";

const methods = {
  BankAgency: function (data) {
    return data.BankAgency + '-' + data.BankAgencyDigit;
  },
  BankAccount: function (data) {
    return data.BankAccount + '-' + data.BankAccountDigit;
  },
  ShowConciliated: function (data){
    if(data.Amount){
      return this.conciliated.Amount == data.Amount;
    }
    else{
      return false;
    }
  },
}

export default {
  name: "BankConciliationTransfer",
  components: {
    Accordion,
    AccordionTab,
    TableList,
    DateField,
    DecimalField
  },
  props: {
    filterData:{
      type: Object,
      required: true,
    },
    conciliated:{
      type: Object,
      required: true,
    },
  },
  data(){
    return {
      tableName: 'Transferências',
      headers: [
        { field: "Bank.Code", label: "", type:"bankImgByCode", classHeader: 'text-left', classField: 'text-center' },
        { field: "Bank.Name", label: "Banco", classHeader: 'text-left', classField: 'text-left' },
        { field: "AccountType.Name", label: "Tipo de Conta", classHeader: 'text-left', classField: 'text-left break-line' },
        { field: methods.BankAgency, label: "Agência", type: 'identity', classHeader: 'text-left', classField: 'text-left' },
        { field: methods.BankAccount, label: "Conta", classHeader: 'text-left', classField: 'text-left' },
        { field: "EntryDate", label: "Data", type: 'date', classHeader: 'text-left', classField: 'text-left' },
        { field: "Amount", label: "Valor", type: 'currency', classHeader: 'text-left', classField: 'text-left' },
        { field: "EntryType.Name", label: "Operação", classHeader: 'text-left', classField: 'text-left same-line' },
        { field: "Description", label: "Descrição", classHeader: 'text-left', classField: 'text-left same-line' },
      ],
      additionalActions: [
        { name: 'MakeConciliation', label: 'Conciliar', icon: 'fas fa-exchange-alt', customRule:methods.ShowConciliated.bind({conciliated:this.conciliated}) }
      ],
      listUnconciliatedTransfer: null,

      filter: this.FilterDefault(),
      filterOptions: { ...this.filterData.filterOptions },
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      loading: false,
      activeIndex: null
    }
  },
  mounted(){
    setTimeout(() => {
        this.activeIndex = 0;
    }, 70);
  },
  computed:{
    isFilterDateInvalid(){
      return this.filter.DateInitial > this.filter.DateEnd;
    },
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListBankConciliation();
    },
    "pagination.RowsPerPage": function () {
      this.ListBankConciliation();
    },
    "activeIndex": function () {
      this.RemoveBodyClass('.p-accordion.p-component', 'p-component')
    },
    "filter.BankAccounts"(){
      this.filterOptions.Banks = this.filterData.filterAux.BankAccounts.map(elem => elem.Bank).sort((a, b) => a.Name.localeCompare(b.Name));
    },
    "filter.BankCode": function () {
      if(this.filter.BankCode){
        this.filterOptions.BankAccounts = this.filterData.filterAux.BankAccounts.filter(elem => elem.Bank.Code == this.filter.BankCode);
      }else{
        this.filterOptions.BankAccounts = this.filterData.filterAux.BankAccounts;
      }

      if (!this.filterOptions.BankAccounts.find(elem => elem.Code == this.filter.BankAccountsCode)) {
        this.filter.BankAccountsCode = null;
      }
    },
  },
  methods:{
    FilterDefault: function () {
      let dateIni;
      let dateFim;
      if(this.conciliated.EntryType.Code == "D"){
        dateIni = this.conciliated.EntryDate;
        dateFim = this.AddDays(this.conciliated.EntryDate, 3);
      }else{
        dateIni = this.AddDays(this.conciliated.EntryDate, -3);
        dateFim = this.conciliated.EntryDate;
      }
      return {
        DateInitial: dateIni,
        DateEnd: dateFim,
        AmountInitial: this.conciliated.Amount,
        AmountEnd: this.conciliated.Amount,
        Description: null,
        AccountsTransferCategoryCode: null
      }
    },

    AddDays(date, days) {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result.toJSON().split('T')[0];
    },

    GetParams(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.EntryType.Code": this.conciliated.EntryType.Code == 'C' ? 'D' : 'C',
        "Object.Bank.Code": this.filter.BankCode,
        "Object.Description": this.filter.Description,
        "Object.SupplierName": this.filter.Client,
        "DateInitial": this.filter.DateInitial,
        "DateEnd": this.filter.DateEnd,
        "AmountInitial": this.conciliated.Amount,
        "AmountEnd": this.conciliated.Amount,
        "AccountsTransferCategory.Code": this.filter.AccountsTransferCategoryCode,
        "IdBankStatementDetailsExcluded": this.conciliated.Id,
        "CodeBankAccountExcluded": this.conciliated.BankAccountCode,
        "IsUnconciliated": true
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },
    ListUnconciliatedTransfer() {
      this.listUnconciliatedTransfer = [];
      this.loading = true;
      const params = this.GetParams();
      this.$store.dispatch("ListBankConciliation", params)
        .then(response => {
          this.listUnconciliatedTransfer = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Tente novamente.", "danger", "Um erro ocorreu ao listar as conciliações.", error);
        })
        .finally(() => {
          this.loading = false;
          this.activeIndex = null;
        });
    },
    MakeConciliation(toConciliate) {
      this.$emit('MakeConciliation', toConciliate);
    },
    RemoveBodyClass(locate, classToRemove) {
      const el = document.querySelector(locate);
      if(el){
        el.classList.remove(classToRemove);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.align-vertical-bottom {
  display: flex;
  justify-content: end; /* align horizontal */
  align-items: end;
  padding-bottom: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/BankConciliation/BankConciliationTransfer.vue